import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { GlosarioService } from '../../../services/glosario-entidad.service';
import { IModificarGlosarioRequest } from '../../../dto/glosario-entidad/glosario-entidad.dto';
import { AlertaModalService } from '../../../services/util/alerta-modal.service';
import { TranslateService } from '@ngx-translate/core';
import { EntidadService } from '../../../services/entidad.service';
import { EntidadDto } from '../../../dto/entidad/entidad.dto';

@Component({
  selector: 'app-form-editar-glosario',
  templateUrl: './form-editar-glosario.component.html',
  styleUrl: './form-editar-glosario.component.scss',
})
export class FormEditarGlosarioComponent implements OnInit {
  @Output() glosarioActualizado = new EventEmitter<void>();
  @ViewChild('modalGlosario', { static: false })
  modalGlosario!: ElementRef;
  @Input() conceptoData: { concepto: string; definicion: string } | null = null;
  glosarioId = 0;
  formularioEditar: FormGroup;
  formularioGuardar: FormGroup;
  entidades: EntidadDto[] = [];

  // Multilenguaje
  glosarioText: any = {};
  isEditar: boolean = true;
  constructor(
    private readonly fb: FormBuilder,
    private readonly glosarioService: GlosarioService,
    private readonly alertService: AlertaModalService,
    private readonly translate: TranslateService,
    private readonly entidadService: EntidadService
  ) {
    this.formularioEditar = this.fb.group({
      concepto: ['', Validators.required],
      definicion: ['', Validators.required],
    });
    this.formularioGuardar = this.fb.group({
      entidadId: ['', Validators.required],
      termino: ['', Validators.required],
      definicion: ['', Validators.required],
    });
  }

  ngOnInit(): void {
    // Multilenguaje
    this.translate.stream('glosario').forEach(text => {
      for (let key of Object.keys(text)) {
        this.glosarioText[key] = text[key];
      }
    });
    this.obtenerEntidades();
  }
  editarGlosario(event: any) {
    this.isEditar = true;
    this.modalGlosario.nativeElement.click();
    this.glosarioId = event.item.id;
    if (event?.item) {
      this.formularioEditar.patchValue({
        concepto: event.item.termino || '',
        definicion: event.item.definicion || '',
        estado: event.item.estado
      });
    }
  }

  guardarNuevaPalabra() {
    this.isEditar = false;
    this.modalGlosario.nativeElement.click();
  }

  onGuardarEdicion() {
    let datosActualizados: IModificarGlosarioRequest = this.formularioEditar.value;
    this.glosarioService
      .modificarGlosario(this.glosarioId, datosActualizados)
      .subscribe({
        next: async () => {
          await this.alertService.exito(this.glosarioText['exito']);
          this.glosarioActualizado.emit();
        },
        error: async () => {
          await this.alertService.error(this.glosarioText['error']);
        },
      });
  }

  onGuardarGlosario() {
    let datosNuevoGlosario: IModificarGlosarioRequest = this.formularioGuardar.value;
    datosNuevoGlosario = {
      ...datosNuevoGlosario,
      entidadId: +datosNuevoGlosario.entidadId!,
    }
    this.glosarioService.guardarGlosario(datosNuevoGlosario).subscribe({
      next: async () => {
        await this.alertService.exito(this.glosarioText['exito_guardar']);
      },
      error: async () => {
        await this.alertService.error(this.glosarioText['error_guardar']);
      },
    });
  }

  private obtenerEntidades() {
    this.entidadService.obtenerEntidades().subscribe(entidades => {
      this.entidades = entidades;
    });
  }
}
